import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import Textarea from 'react-textarea-autosize'

import pencilIconSrc from '!svg-inline!images/svg/pencil.svg'

import './style.styl'

const InlineEdit = ({ className, ...props }) => (
  <div className={cx('inline-edit', className)}>
    <IconSVG src={pencilIconSrc} />
    <Textarea {...props} className="flex-1" />
  </div>
)

export default InlineEdit



// WEBPACK FOOTER //
// ./src/scripts/components/shared/InlineEdit/index.js